import type { Question, QuestionStimulus, QuestionType } from '@examflow/core';

/**
 * IELTS 考试等级 (Band Score 0-9，每0.5分一个等级)
 */
export enum IELTSLevel {
  Band0 = '0',
  Band05 = '0.5',
  Band1 = '1',
  Band15 = '1.5',
  Band2 = '2',
  Band25 = '2.5',
  Band3 = '3',
  Band35 = '3.5',
  Band4 = '4',
  Band45 = '4.5',
  Band5 = '5',
  Band55 = '5.5',
  Band6 = '6',
  Band65 = '6.5',
  Band7 = '7',
  Band75 = '7.5',
  Band8 = '8',
  Band85 = '8.5',
  Band9 = '9',
}

/**
 * IELTS 考试部分
 */
export enum IELTSSection {
  /** 听力 */
  LISTENING = 'listening',
  /** 阅读 */
  READING = 'reading',
  /** 写作 */
  WRITING = 'writing',
  /** 口语 */
  SPEAKING = 'speaking',
}

/**
 * IELTS 考试类型
 */
export enum IELTSTestType {
  /** 学术类（Academic）- 适用于留学申请 */
  ACADEMIC = 'academic',
  /** 培训类（General Training）- 适用于移民申请 */
  GENERAL = 'general',
}

/**
 * IELTS 题目扩展接口
 */
export interface IELTSQuestion extends Question {
  /** 对应的 IELTS 等级 */
  ieltsLevel?: IELTSLevel;
  /** 所属考试部分 */
  section?: IELTSSection;
  /** 题目序号（在该部分中） */
  orderInSection?: number;
}

/**
 * IELTS 听力题目（single_choice + audio stimulus）
 */
export interface IELTSListeningQuestion extends IELTSQuestion {
  type: QuestionType.SINGLE_CHOICE;
  stimulus: Extract<QuestionStimulus, 'audio'>[];
  /** 音频URL */
  audioUrl: string;
  /** 音频播放次数限制 */
  maxPlayCount?: number;
  /** 音频时长（秒） */
  audioDuration?: number;
}

/**
 * IELTS 阅读题目（single_choice + passage stimulus）
 */
export interface IELTSReadingQuestion extends IELTSQuestion {
  type: QuestionType.SINGLE_CHOICE;
  stimulus: Extract<QuestionStimulus, 'passage'>[];
  /** 阅读材料 */
  passage: string;
  /** 材料来源 */
  source?: string;
}

/**
 * IELTS 分数映射
 */
export interface IELTSScoreMapping {
  level: IELTSLevel;
  cefrEquivalent: string;
  description: string;
}

/**
 * IELTS 考试结果
 */
export interface IELTSResult {
  /** 总分（四个部分的平均分，四舍五入到0.5分） */
  totalScore: number;
  /** 等级 */
  level: IELTSLevel;
  /** 各部分得分 */
  sectionScores: Record<IELTSSection, number>;
  /** 考试类型 */
  testType: IELTSTestType;
  /** 及格（通常6.0分以上） */
  passed: boolean;
  /** 详细评价 */
  evaluation: string;
}
